import { getPercentages } from '@/components/admin/matchup-list/matchup-item.component';
import { wagerArr } from '@/utils/wager.utils';

export function getTotalPointsPossible(appId, earned, matchups) {
  let total = earned;
  for (let m of Object.values(matchups)) {
    // if a winner has been chosen, skip
    if (m.winner) continue;

    // if m is a matchup with penalty, no pick exists,
    // and both teams have been assigned,
    // subtract min wager for that pick
    if (
      m.penalty &&
      !m.picks?.[appId] &&
      m.comp1 &&
      m.comp2
    ) {
      const minWager = Number(wagerArr[m.wager][0]);
      total -= minWager;
      if (isNaN(total)) {
        return;
      }
      continue;
    }

    // if m is not a prop and pick exists,
    // add user's wager for that pick 
    if (m.type === 'matchup' && m.picks && m.picks[appId]) {
      const potWinnings = Number(m.picks[appId].wager);
      total += potWinnings;
      if (isNaN(total)) {
        return;
      }
      continue;
    }
    // if m is a prop and pick exists,
    // add user's wager for that pick 
    if (m.type === 'prop' && m.picks && m.picks[appId]) {
      const potWinnings = Number(m.picks[appId].wager);
      // console.log(potWinnings);
      total += potWinnings;
      if (isNaN(total)) {
        return;
      }
      // add underdog bonus
      const pickData = m.picks[appId];
      const percentages = getPercentages(m.picks, m);
      // console.log(percentages);
      const udBonus = pickData ?
        Math.round(
          Number(pickData.wager) *
          (1 - (.01 * percentages[`c${pickData?.pick?.substring(4)}`])))
        : 0;

      if (isNaN(udBonus)) return;
      total += udBonus;
      if (isNaN(total)) {
        return;
      }
      continue;
    }
    // console.log(total);
  }
  return total;
}